import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../service/seo.service';
import { GlobalComponent } from '../global/global.component';


@Component({
  selector: 'app-forging',
  templateUrl: './forging.component.html',
  styleUrls: ['./forging.component.scss']
})
export class ForgingComponent implements OnInit {

   hostName = GlobalComponent.hostName;
  constructor(private router: Router, private SEOService:SeoService) {window.scroll(0, 0); }

  ngOnInit(): void {
    this.SEOService.updateCanonicalUrl(this.hostName + '/forging');
  }

  
  signup()
    {
      this.router.navigate(['/login/signup']);

    }
}
